module.exports = ".margins{\r\n    margin-top:35px;\r\n    margin-bottom: 35px;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/forbidden/forbidden.component.css
// module id = ./src/app/shared/forbidden/forbidden.component.css
// module chunks = main